export const HIDE_THIRD_PARTY_DIALOG = '_hide_third_party_dialog_floracal';
